import { StyledButton, StyledBox } from './TertiaryButton.styles';

const TertiaryButton = ({ color, children, ...rest }: any) => (
  <StyledButton disableRipple color={color} {...rest}>
    <StyledBox color={color}>{children}</StyledBox>
  </StyledButton>
);

export default TertiaryButton;
